<div class="menubar-mobile-backdrop" (click)="closeMobileMenu()"></div>
<div id="menubar" class="menubar-inverse ">
    <div class="menubar-fixed-panel">
        <div>
            <a class="btn btn-icon-toggle btn-default menubar-toggle" data-toggle="menubar" href="javascript:void(0);">
                <i class="ph ph-list"></i>
            </a>
        </div>
        <div class="expanded">
            <a href="">
                <span class="text-lg text-bold text-primary ">Rishabh</span>
            </a>
        </div>
    </div>
    <div class="menubar-scroll-panel" (click)="closeMobileMenu()">

        <div class="expanded app-logo-header-info">
        <img *ngIf="brand.id" class="app-logo-full" [src]="brand.menuFullLogoPath" alt="">
        <img *ngIf="brand.id" class="app-logo-short" [src]="brand.menuShortLogoPath" alt="">
        </div>
        <!-- BEGIN MAIN MENU -->
        <!-- Section labels (.nav-section-label) are siblings of the nav
             <li>s, never wrapper <div>s — every existing
             ".gui-controls > li.nav-menu" CSS selector (active state, icon
             centering, the 769-1200px icon-only rail, the Reports flyout;
             see menu.component.css) depends on li.nav-menu being a DIRECT
             child of this <ul>, so wrapping groups in container elements
             would silently break all of those rules. Each label's *ngIf is
             the OR of every item in that group's own *ngIf, so a group
             with every item hidden never shows a dangling heading. Items
             themselves keep their original *ngIf/routerLink/icon exactly
             as before — only reordered to sit next to their group. -->
        <ul id="main-menu" class="gui-controls">
            <!-- BEGIN DASHBOARD -->
            <li *ngIf="loginMode == 'WEB_ADMIN' && isFranchise == 0" routerLinkActive="active" class="nav-menu">
                <a [routerLink]="['/dashboard']" class="dash" title="{{ 'dashboard' | translate }}">
                    <div class="gui-icon"><i class="ph ph-squares-four"></i></div>
                    <span class="title">{{ 'dashboard' | translate }}</span>
                </a>
            </li><!--end /menu-li -->
            <!-- END DASHBOARD -->
            <!-- BEGIN INSIGHTS -->
            <li *ngIf="loginMode == 'WEB_ADMIN' && isFranchise == 0" routerLinkActive="active" class="nav-menu">
                <a [routerLink]="['/insights']" class="insights" title="{{ 'insights' | translate }}">
                    <div class="gui-icon"><i class="ph ph-chart-line"></i></div>
                    <span class="title">{{ 'insights' | translate }}</span>
                </a>
            </li><!--end /menu-li -->
            <!-- END INSIGHTS -->

            <!-- ============ PEOPLE ============ -->
            <li class="nav-section-label"
                *ngIf="(loginMode == 'WEB_ADMIN' && isFranchise == 0 && permissions.ADMISSION_ENQUIRY_VIEW == 'ENABLED') || (loginMode == 'WEB_ADMIN' && (permissions.SCHOOL_STAFFS_MANAGEMENT == 'ENABLED' || permissions.SCHOOL_STUDENT_MANAGEMENT == 'ENABLED'))">
                <span>{{ 'navSectionPeople' | translate }}</span>
            </li>
            <!-- BEGIN ADMISSION ENQUIRY -->
            <li *ngIf="loginMode == 'WEB_ADMIN' && isFranchise == 0 && permissions.ADMISSION_ENQUIRY_VIEW == 'ENABLED'" routerLinkActive="active" class="nav-menu">
                <a [routerLink]="['/admission-enquiry']" class="admission-inquiry" title="{{ 'admissionEnquiry' | translate }}">
                    <div class="gui-icon"><i class="ph ph-user-plus"></i></div>
                    <span class="title">{{ 'admissionEnquiry' | translate }}</span>
                </a>
            </li><!--end /menu-li -->
            <!-- END ADMISSION ENQUIRY -->
            <li *ngIf="loginMode == 'WEB_ADMIN' && (permissions.SCHOOL_STAFFS_MANAGEMENT == 'ENABLED' || permissions.SCHOOL_STUDENT_MANAGEMENT == 'ENABLED')"
                routerLinkActive="active" class="nav-menu">
                <a [routerLink]="['/groups']" class="groups" title="{{ 'staffsStudents' | translate }}">
                    <div class="gui-icon"><i class="ph ph-users"></i></div>
                    <span class="title">{{ 'staffsStudents' | translate }}</span>
                </a>
            </li>
            <li *ngIf="loginMode == 'WEB_ADMIN'" routerLinkActive="active" class="nav-menu hide">
                <a [routerLink]="['/broadcast']" class="broadcast" title="{{ 'broadcasts' | translate }}">
                    <div class="gui-icon"><i class="ph ph-envelope-simple"></i></div>
                    <span class="title">{{ 'broadcasts' | translate }}</span>
                </a>
            </li>

            <!-- ============ ACADEMICS ============ -->
            <li class="nav-section-label"
                *ngIf="(loginMode == 'WEB_ADMIN' && permissions.CLASS_MANAGEMENT == 'ENABLED') || permissions.EXAM_MANAGEMENT == 'ENABLED' || (loginMode == 'WEB_ADMIN' && permissions.ACADEMIC_MANAGEMENT == 'ENABLED') || (academicCalendarServiceEnabled === true && loginMode == 'WEB_ADMIN')">
                <span>{{ 'navSectionAcademics' | translate }}</span>
            </li>
            <li routerLinkActive="active" class="nav-menu"
                *ngIf="loginMode == 'WEB_ADMIN' && permissions.CLASS_MANAGEMENT == 'ENABLED'">
                <a [routerLink]="['/class']" class="class-manage" title="{{ 'classManagement' | translate }}">
                    <div class="gui-icon"><i class="ph ph-house"></i></div>
                    <span class="title">{{ 'classManagement' | translate }}</span>
                </a>
            </li>
            <li routerLinkActive="active" class="nav-menu" *ngIf="permissions.EXAM_MANAGEMENT == 'ENABLED'">
                <a [routerLink]="['/exams']" class="exams" title="{{ 'examManagement' | translate }}">
                    <div class="gui-icon"><i class="ph ph-file-text"></i></div>
                    <span class="title">{{ 'examManagement' | translate }}</span>
                </a>
            </li>
            <li routerLinkActive="active" class="nav-menu"
                *ngIf="loginMode == 'WEB_ADMIN' && permissions.ACADEMIC_MANAGEMENT == 'ENABLED'">
                <a [routerLink]="['/academics']" class="academic" title="{{ 'manageAcademics' | translate }}">
                    <div class="gui-icon"><i class="ph ph-graduation-cap"></i></div>
                    <span class="title">{{ 'manageAcademics' | translate }}</span>
                </a>
            </li>
            <li *ngIf="academicCalendarServiceEnabled === true && loginMode == 'WEB_ADMIN'" routerLinkActive="active"
                class="nav-menu">
                <a [routerLink]="['/academic/calendar']" class="message" title="{{ 'academicCalendar' | translate }}">
                    <div class="gui-icon broadcast-icon-container">
                        <i class="ph ph-calendar"></i>
                    </div>
                    <span class="title">{{ 'academicCalendar' | translate }}</span>
                </a>
            </li>

            <!-- ============ FINANCE ============ -->
            <li class="nav-section-label"
                *ngIf="(loginMode == 'WEB_ADMIN' && permissions.FEES_MANAGEMENT == 'ENABLED') || (loginMode == 'WEB_ADMIN' && permissions.EXPENSES_MANAGEMENT == 'ENABLED')">
                <span>{{ 'navSectionFinance' | translate }}</span>
            </li>
            <li class="nav-menu" [class.active]="isFeesActive"
                *ngIf="loginMode == 'WEB_ADMIN' && permissions.FEES_MANAGEMENT == 'ENABLED'">
                <a [routerLink]="['/fees']" class="fees" title="{{ 'feesManagement' | translate }}">
                    <div class="gui-icon"><i class="ph ph-credit-card"></i></div>
                    <span class="title">{{ 'feesManagement' | translate }}</span>
                </a>
            </li>
            <li routerLinkActive="active" class="nav-menu"
                *ngIf="loginMode == 'WEB_ADMIN' && permissions.EXPENSES_MANAGEMENT == 'ENABLED'">
                <a [routerLink]="['/expense']" class="expense" title="{{ 'expenseManagement' | translate }}">
                    <div class="gui-icon"><i class="ph ph-credit-card"></i></div>
                    <span class="title">{{ 'expenseManagement' | translate }}</span>
                </a>
            </li>

            <!-- ============ MESSAGES ============ -->
            <li class="nav-section-label"
                *ngIf="(loginMode == 'WEB_ADMIN' && permissions.MESSAGES == 'ENABLED') || (loginMode == 'WEB_ADMIN' && permissions.BROADCAST_VIEW == 'ENABLED')">
                <span>{{ 'navSectionMessages' | translate }}</span>
            </li>
            <li routerLinkActive="active" class="nav-menu"
                *ngIf="loginMode == 'WEB_ADMIN' && permissions.MESSAGES == 'ENABLED'">
                <a [routerLink]="['/message']" class="message" title="{{ 'smsManagement' | translate }}">
                    <div class="gui-icon"><i class="ph ph-envelope-simple"></i></div>
                    <span class="title">{{ 'smsManagement' | translate }}</span>
                </a>
            </li>
            <li routerLinkActive="active" class="nav-menu"
                *ngIf="loginMode == 'WEB_ADMIN' && permissions.BROADCAST_VIEW == 'ENABLED'">
                <a [routerLink]="['/broadcast']" class="message" title="{{ 'manageBroadcast' | translate }}">
                    <div class="gui-icon broadcast-icon-container">
                        <i class="ph ph-fill ph-megaphone"></i>
                    </div>
                    <span class="title">{{ 'manageBroadcast' | translate }}</span>
                </a>
            </li>
            <!--<li routerLinkActive="active" class="nav-menu">
        <a [routerLink]="['/inventory']" class="inventory">
          <div class="gui-icon"><i class="ph ph-share"></i></div>
          <span class="title">Inventory Management</span>
        </a>
      </li>-->
            <!--<li routerLinkActive="active" class="nav-menu">
        <a [routerLink]="['/hostel']" class="hostel">
          <div class="gui-icon"><i class="ph ph-bed"></i></div>
          <span class="title">Hostel</span>
        </a>
      </li>-->

            <!-- ============ SERVICES ============ -->
            <li class="nav-section-label"
                *ngIf="(loginMode == 'WEB_ADMIN' && permissions.VEHICLE_MANAGEMENT == 'ENABLED') || tcGeneratorEnabled || idCardGenerationEnabled || staffIdCardEnabled || (loginMode == 'WEB_ADMIN' && isReportServiceEnabled===true) || certificateManagerEnabled || hourhiveServiceEnabled || doorwayServiceEnabled || trackifyServiceEnabled || nexusServiceEnabled">
                <span>{{ 'navSectionServices' | translate }}</span>
            </li>
            <li [class.active]="isTransportActive" class="nav-menu"
                *ngIf="loginMode == 'WEB_ADMIN' && permissions.VEHICLE_MANAGEMENT == 'ENABLED'">
                <a [routerLink]="['/transport']" class="transport" title="{{ 'transport' | translate }}">
                    <div class="gui-icon"><i class="ph ph-bus"></i></div>
                    <span class="title">{{ 'transport' | translate }}</span>
                </a>
            </li>

            <ng-container *ngIf="tcGeneratorEnabled">
                <li routerLinkActive="active" class="nav-menu" *ngIf="loginMode == 'WEB_ADMIN' ">
                    <a [routerLink]="['/tc']" class="settings" title="{{ 'tcGenerator' | translate }}">
                        <div class="gui-icon"><i class="ph ph-article tc-generator-icon"></i></div>
                        <span class="title">{{ 'tcGenerator' | translate }}</span>
                    </a>
                </li>
            </ng-container>

                <ng-container *ngIf="idCardGenerationEnabled || staffIdCardEnabled">
                <li routerLinkActive="active" class="nav-menu" *ngIf="loginMode == 'WEB_ADMIN' ">
                    <a [routerLink]="['/id-card']" class="settings" title="{{ 'idCard' | translate }}">
                        <div class="gui-icon"><i class="ph ph-identification-card tc-generator-icon"></i></div>
                        <span class="title">{{'idCard' | translate}}</span>
                    </a>
                </li>
            </ng-container>

            <li class="nav-menu" [class.active]="pageInfo === '/report/transfer-certificate' || pageInfo === '/report/category-wise' || pageInfo === '/report/attendance-report' || pageInfo === '/report/pending-fees' || pageInfo === '/report/expense-report' || pageInfo === '/report/checkin-checkout-report' || pageInfo === '/report/fees-overdue-report'"
                *ngIf="loginMode == 'WEB_ADMIN' && (isReportServiceEnabled===true)">
                <a (click)="openReportTypes()" class="settings" title="{{ 'reports' | translate }}" [ngClass]="{
                  'opened-report-section' : openReport,
                  'opened-report-section-disabled' : !openReport,
                }">
                    <div [ngClass]="{
                  'report-icon': (pageInfo === '/report/transfer-certificate' || pageInfo === '/report/category-wise' || pageInfo === '/report/attendance-report'|| pageInfo==='/report/pending-fees'),
                  'report-icon-disabled': !(pageInfo === '/report/transfer-certificate' || pageInfo === '/report/category-wise' || pageInfo === '/report/attendance-report' || pageInfo === '/report/pending-fees')
                }">

                        <i class="ph ph-fill ph-chart-bar report-icon-menu"></i>
                    </div>

                    <div class="report-string-with-icon"></div>
                    <span class="reports-link">{{ 'reports' | translate }} </span>
                    <span [ngClass]="{
                    'report-main-icon' : !openReport,
                    'report-main-icon-active' : openReport
                  }"><i class="ph ph-caret-right"></i></span>
                </a>
                <div class="report-option-type">
                    <div [ngClass]="{
                    'report-option-enabled' : openReport,
                    'report-option' : !openReport
                  }">
                        <div [ngClass]="{
                      'report-links-active' : pageInfo ==='/report/category-wise',
                      'report-links' : pageInfo !=='/report/category-wise'
                    }" (click)="navigateReportSection('/report/category-wise')">{{ 'categoryWise' | translate }}
                </div>
                        <div
                        *ngIf="isPendingFeeServiceEnabled == true || isPendingFeeServiceEnabled == 'true'"
                        [ngClass]="{
                                        'report-links-active' : pageInfo ==='/report/pending-fees',
                                          'report-links' : pageInfo !=='/report/pending-fees'
                                        }" (click)="navigateReportSection('/report/pending-fees')">{{ 'pendingFees' | translate }}</div>
                        <div [ngClass]="{
                      'report-links-active' : pageInfo ==='/report/transfer-certificate',
                      'report-links' : pageInfo !=='/report/transfer-certificate'
                    }" (click)="navigateReportSection('/report/transfer-certificate')">{{ 'tcBirthCertificate' | translate }}</div>
                        <div [ngClass]="{
                      'report-links-active' : pageInfo ==='/report/attendance-report',
                      'report-links' : pageInfo !=='/report/attendance-report'
                    }" (click)="navigateReportSection('/report/attendance-report')">{{ 'attendanceReport' | translate }}</div>
                     <div [ngClass]="{
                      'report-links-active' : pageInfo ==='/report/expense-report',
                      'report-links' : pageInfo !=='/report/expense-report'
                    }" (click)="navigateReportSection('report/expense-report')">{{ 'expenseData' | translate }}</div>
                    <div  *ngIf="isCheckinCheckoutServiceEnabled"
                    [ngClass]="{
                      'report-links-active' : pageInfo ==='/report/checkin-checkout-report',
                      'report-links' : pageInfo !=='/report/checkin-checkout-report'
                    }" (click)="navigateReportSection('/report/checkin-checkout-report')">{{ 'checkinCheckout' | translate }}</div>
                    <div [ngClass]="{
                      'report-links-active' : pageInfo ==='/report/fees-overdue-report',
                      'report-links' : pageInfo !=='/report/fees-overdue-report'
                    }" (click)="navigateReportSection('report/fees-overdue-report')">{{ 'feesOverdue' | translate }}</div>
                    </div>


                </div>
            </li>

            <li *ngIf="certificateManagerEnabled && loginMode == 'WEB_ADMIN'" routerLinkActive="active " class="nav-menu">
                <a (click)="openCertificateManager()" class="settings cm-link" title="{{ 'certificateManager' | translate }}">
                    <div class="gui-icon cm-icon-container"><i class="ph ph-article tc-generator-icon"></i></div>

                    <span class="title">
                        <div class="cm-manager-with-recognify">
                            <div><img src="../../assets/img/recognify.png" class="recognify-logo-icon" alt=""></div>
                            <div>{{ 'certificateManager' | translate }}</div>
                        </div>

                    </span>
                </a>
            </li>
               <li  *ngIf="hourhiveServiceEnabled && loginMode == 'WEB_ADMIN'" routerLinkActive="active " class="nav-menu">
                <a  (click)="openExternalService('hourhive')"  target="_blank" class="settings cm-link" title="Staff Attendance">
                    <div class="gui-icon cm-icon-container"><i class="ph ph-clock tc-generator-icon"></i></div>

                    <span class="title">
                        <div class="cm-manager-with-recognify">
                            <div><img src="../../assets/img/hourhive_logo.png" class="recognify-logo-icon" alt=""></div>
                            <div>Staff Attendance</div>
                        </div>

                    </span>
                </a>
            </li>

               <li *ngIf="doorwayServiceEnabled" routerLinkActive="active " class="nav-menu">
                <a  (click)="openExternalService('doorway')"  target="_blank" class="settings cm-link" title="Vistor Management">
                    <div class="gui-icon cm-icon-container"><i class="ph ph-users tc-generator-icon"></i></div>

                    <span class="title">
                        <div class="cm-manager-with-recognify">
                             <div><img src="../../assets/img/doorway.png" class="recognify-logo-icon" alt=""></div>
                            <div>Vistor Management</div>
                        </div>
                    </span>
                </a>
            </li>
                  <li *ngIf="trackifyServiceEnabled" routerLinkActive="active " class="nav-menu">
                <a  (click)="openExternalService('trackify')"  target="_blank" class="settings cm-link" title="Trackify">
                    <div class="gui-icon cm-icon-container"><i class="ph ph-users tc-generator-icon"></i></div>

                    <span class="title">
                        <div class="cm-manager-with-recognify">
                             <div><img src="../../assets/img/track.png" class="recognify-logo-icon" alt=""></div>
                            <div>Trackify</div>
                        </div>
                    </span>
                </a>
            </li>
             <li  *ngIf="nexusServiceEnabled" routerLinkActive="active " class="nav-menu">
                <a  (click)="openExternalService('LIBRARY_MANAGEMENT')"  target="_blank" class="settings cm-link" title="Library Management">
                    <div class="gui-icon cm-icon-container"><i class="ph ph-book-open tc-generator-icon"></i></div>

                    <span class="title">
                        <div class="cm-manager-with-recognify">
                            <div><img src="../../assets/img/nexus-logo.png" class="recognify-logo-icon" alt=""></div>
                            <div>Library Management</div>
                        </div>

                    </span>
                </a>
            </li>

            <!-- ============ (ungrouped, bottom) ============ -->
            <li routerLinkActive="active" class="nav-menu"
                *ngIf="loginMode == 'WEB_ADMIN' && (permissions.SETTINGS_MANAGEMENT == 'ENABLED' || permissions.STUDENT_RE_ACTIVATE == 'ENABLED')">
                <a [routerLink]="['/settings']" class="settings" title="{{ 'settings' | translate }}">
                    <div class="gui-icon"><i class="ph ph-gear"></i></div>
                    <span class="title">{{ 'settings' | translate }}</span>
                </a>
            </li>

            <!-- Franchise Menu -->
            <li *ngIf="isFranchise == 1" routerLinkActive="active" class="nav-menu">
                <a [routerLink]="['/franchise/dashboard']" class="dash" title="{{ 'dashboard' | translate }}">
                    <div class="gui-icon"><i class="ph ph-squares-four"></i></div>
                    <span class="title">{{ 'dashboard' | translate }}</span>
                </a>
            </li>
            <li routerLinkActive="active" class="nav-menu" *ngIf="isFranchise == 1">
                <a [routerLink]="['/franchise/schoollist']" class="class-manage" title="{{ 'schools' | translate }}">
                    <div class="gui-icon"><i class="ph ph-buildings"></i></div>
                    <span class="title">{{ 'schools' | translate }}</span>
                </a>
            </li>
            <li routerLinkActive="active" class="nav-menu" *ngIf="isFranchise == 1">
                <a [routerLink]="['/franchise/addschool']" class="class-manage" title="{{ 'addSchool' | translate }}">
                    <div class="gui-icon"><i class="ph ph-plus-square"></i></div>
                    <span class="title">{{ 'addSchool' | translate }}</span>
                </a>
            </li>
            <li routerLinkActive="active" class="nav-menu" *ngIf="isFranchise == 1">
                <a [routerLink]="['/franchise/settings']" class="settings" title="{{ 'settings' | translate }}">
                    <div class="gui-icon"><i class="ph ph-gear"></i></div>
                    <span class="title">{{ 'settings' | translate }}</span>
                </a>
            </li>
            <!-- End Franchise Menu -->

        </ul><!--end .main-menu -->
        <!-- END MAIN MENU -->


        <div class="menubar-foot-panel" *ngIf="isFranchise == 1">
            <small class="no-linebreak hidden-folded">
                <span class="opacity-75">{{ 'copyright' | translate }} &copy; {{currentYear}}</span> <strong> {{ 'synclovisSystems' | translate }}</strong>
            </small>
        </div>

    </div><!--end .menubar-scroll-panel-->
</div><!--end #menubar-->
<!-- END MENUBAR -->

<!-- BEGIN OFFCANVAS RIGHT -->
<div class="offcanvas">

    <!-- BEGIN OFFCANVAS SEARCH -->
    <div id="offcanvas-search" class="offcanvas-pane width-8">
        <div class="offcanvas-head">
            <header class="text-primary">{{ 'searchStudent' | translate }}</header>
            <div class="form-group">
                <div class="input-group">

                    <div class="input-group-content">
                        <input type="text" class="form-control" id="username9">
                    </div>
                    <span class="input-group-addon"><span class="glyphicon glyphicon-search fa-lg"></span></span>
                </div>
            </div>
            <div class="offcanvas-tools">
                <a class="btn btn-icon-toggle btn-default-light pull-right" data-dismiss="offcanvas">
                    <i class="md md-close"></i>
                </a>
            </div>
        </div>
        <div class="offcanvas-body no-padding">
            <ul class="list ">
                <li class="tile">
                    <a class="tile-content ink-reaction" href="#offcanvas-chat" data-toggle="offcanvas"
                        data-backdrop="false">
                        <div class="tile-icon">
                            <img src="assets/img/avatar4.jpg?1404026791" alt="" />
                        </div>
                        <div class="tile-text">
                            {{ 'shafeequeS' | translate }}
                            <small>+91 9995818114</small>
                        </div>
                    </a>
                </li>
            </ul>
        </div><!--end .offcanvas-body -->
    </div><!--end .offcanvas-pane -->
    <!-- END OFFCANVAS SEARCH -->

    <!-- BEGIN OFFCANVAS CHAT -->
    <div id="offcanvas-chat" class="offcanvas-pane style-default-light width-12">
        <div class="offcanvas-head style-default-bright">
            <header class="text-primary">{{ 'chatWithShafeequesParent' | translate }}</header>
            <div class="offcanvas-tools">
                <a class="btn btn-icon-toggle btn-default-light pull-right" data-dismiss="offcanvas">
                    <i class="md md-close"></i>
                </a>
                <a class="btn btn-icon-toggle btn-default-light pull-right" href="#offcanvas-search"
                    data-toggle="offcanvas" data-backdrop="false">
                    <i class="md md-arrow-back"></i>
                </a>
            </div>
        </div>
        <div class="offcanvas-body">
            <ul class="list-chats">
                <li>
                    <div class="chat">
                        <div class="chat-avatar"><img class="img-circle" src="assets/img/avatar1.jpg?1403934956"
                                alt="" /></div>
                        <div class="chat-body">
                            {{ 'yesItIsIndeedVeryBeautiful' | translate }}
                            <small>10:03 {{ 'pm' | translate }}</small>
                        </div>
                    </div><!--end .chat -->
                </li>
                <li class="chat-left">
                    <div class="chat">
                        <div class="chat-avatar"><img class="img-circle" src="assets/img/avatar9.jpg?1404026744"
                                alt="" /></div>
                        <div class="chat-body">
                            {{ 'didYouSeeTheChanges' | translate }}
                            <small>10:02 {{ 'pm' | translate }}</small>
                        </div>
                    </div><!--end .chat -->
                </li>
                <li>
                    <div class="chat">
                        <div class="chat-avatar"><img class="img-circle" src="assets/img/avatar1.jpg?1403934956"
                                alt="" /></div>
                        <div class="chat-body">
                            {{ 'iJustArrivedAtWorkItWasQuiteBusy' | translate }}
                            <small>06:44{{ 'pm' | translate }}</small>
                        </div>
                        <div class="chat-body">
                            {{ 'iWillTakeLookInAMinute' | translate }}
                            <small>06:45{{ 'pm' | translate }}</small>
                        </div>
                    </div><!--end .chat -->
                </li>
                <li class="chat-left">
                    <div class="chat">
                        <div class="chat-avatar"><img class="img-circle" src="assets/img/avatar9.jpg?1404026744"
                                alt="" /></div>
                        <div class="chat-body">
                            {{ 'theColorsAreMuchBetterNow' | translate }}
                        </div>
                        <div class="chat-body">
                            {{ 'theColorsAreBrighterThanBefore' | translate }}
                            {{ 'iHaveAlreadySentAnExample' | translate }}
                            {{ 'thisWillMakeItLookSharper' | translate }}
                            <small>{{ 'mon' | translate }}</small>
                        </div>
                    </div><!--end .chat -->
                </li>
                <li>
                    <div class="chat">
                        <div class="chat-avatar"><img class="img-circle" src="assets/img/avatar1.jpg?1403934956"
                                alt="" /></div>
                        <div class="chat-body">
                            {{ 'areTheColorsOfTheLogoAlreadyAdapted' | translate }}
                            <small>{{ 'lastWeek' | translate }}</small>
                        </div>
                    </div><!--end .chat -->
                </li>
            </ul>
        </div><!--end .offcanvas-body -->
    </div><!--end .offcanvas-pane -->
    <!-- END OFFCANVAS CHAT -->


    <!-- BEGIN OFFCANVAS DEMO RIGHT -->
    <div id="offcanvas-demo-size4" class="offcanvas-pane width-12" style="width:800px">
        <div class="offcanvas-head" style="margin-top: 2em;">
            <div class="col-md-12">
                <div class="text-divider hidden-md hidden-lg"><span>{{ 'email' | translate }}</span></div>
                <h1 class="no-margin">{{ 'accountExpireSoon' | translate }}</h1>
                <div class="btn-group stick-top-right">
                    <a href="#" class="btn btn-icon-toggle btn-default"><i class="md md-delete"></i></a>
                    <a href="#" class="btn btn-icon-toggle btn-default"><i class="md md-reply-all"></i></a>
                    <a href="#" class="btn btn-icon-toggle btn-default"><i class="md md-forward"></i></a>
                </div>
                <span class="pull-right text-default-light">{{ 'today' | translate }} 08:12 {{ 'am' | translate }}</span>
                <strong>{{ 'bluewingsTeam' | translate:{ brandName: brand.name } }}</strong>
                <hr />
                <p class="lead">{{ 'loremIpsumDolorSitAmetConsecteturAdipisicingElitSedDoEiusmodTempor' | translate }}
                    {{ 'incididuntUtLaboreEtDoloreMagnaAliquaUtEnimAdMinimVeniamQuisNostrudExercitation' | translate }}                    
                    {{ 'ullamcoLaborisNisiUtAliquipExEaCommodoConsequatDuisAuteIrureDolorInReprehenderitIn' | translate }}
                    {{ 'voluptateVelitEsseCillumDoloreEuFugiatNullaPariaturExcepteurSintOccaecatCupidatatNon' | translate }}
                    {{ 'proidentSuntInCulpaQuiOfficiaDeseruntMollitAnimIdEstLaborum' | translate }}</p>
                <p class="lead">{{ 'loremIpsumDolorSitAmetConsecteturAdipisicingElitSedDoEiusmodTempor' | translate }}
                    {{ 'incididuntUtLaboreEtDoloreMagnaAliquaUtEnimAdMinimVeniamQuisNostrudExercitation' | translate }}                    
                    {{ 'ullamcoLaborisNisiUtAliquipExEaCommodoConsequatDuisAuteIrureDolorInReprehenderitIn' | translate }}
                    {{ 'voluptateVelitEsseCillumDoloreEuFugiatNullaPariaturExcepteurSintOccaecatCupidatatNon' | translate }}
                    {{ 'proidentSuntInCulpaQuiOfficiaDeseruntMollitAnimIdEstLaborum' | translate }}</p>
                <!-- <p><img class="img-responsive" src="assets/img/img14.jpg?1404589160" alt="" /></p> -->
                <hr />
            </div>
        </div>
        <div class="offcanvas-body">

        </div>
        <div class="force-padding stick-bottom-right">

        </div>
    </div>
    <!-- END OFFCANVAS DEMO RIGHT -->
</div><!--end .offcanvas-->
<!-- END OFFCANVAS RIGHT-->